var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 65,
    id: "bitcoin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.7,
    cy: 32.5,
    r: 31.7,
    fill: "#F5B300"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.1 16.3c1.1.3 2.2.5 3.3.8 1.1.3 2.2.5 3.3.8.3.1.4 0 .5-.3.4-1.7.8-3.3 1.2-5 .1-.3.2-.4.5-.3 1 .3 1.9.5 2.9.7.3.1.3.2.2.4-.4 1.6-.8 3.3-1.2 4.9 0 .1 0 .2-.1.4.8.2 1.7.4 2.5.6.1 0 .2-.2.3-.3.3-1.3.6-2.5 1-3.8l.3-1.2c0-.2.1-.3.3-.2 1 .3 2 .5 3.1.8.1 0 .1.1.2.1-.3 1.3-.6 2.5-.9 3.7-.1.5-.2 1-.4 1.5-.1.3 0 .4.3.5l3.3 1.5c1 .6 1.9 1.4 2.6 2.4.9 1.5 1 3.1.6 4.7-.3 1.1-.7 2.1-1.5 2.9-.6.6-1.4 1-2.2 1.3-.1 0-.2.1-.4.1.4.3.8.5 1.2.8 1.2.9 2 2 2.4 3.4.2 1.1.1 2.3-.2 3.4-.4 1.4-.9 2.6-1.8 3.7-1.1 1.3-2.5 2-4.1 2.2-2.1.3-4.1.1-6.1-.2-.3-.1-.5 0-.6.3-.4 1.6-.8 3.3-1.2 4.9-.1.4-.1.5-.6.3-.9-.2-1.9-.5-2.8-.7-.3-.1-.3-.2-.2-.4.4-1.7.8-3.4 1.3-5 0-.2.1-.3-.1-.4-.8-.2-1.6-.4-2.5-.6-.2.9-.5 1.8-.7 2.7-.2.9-.5 1.8-.7 2.7-.1.2-.1.3-.4.2-1-.3-2-.5-3-.7-.3-.1-.3-.2-.2-.4.4-1.7.8-3.4 1.3-5 0-.1.1-.2.1-.4-2.3-.6-4.6-1.2-7-1.8.2-.4.3-.7.5-1.1.4-.9.8-1.8 1.1-2.6.1-.3.2-.3.5-.3.7.2 1.5.4 2.2.5.8.2 1.4-.2 1.5-.9 1.3-5.1 2.6-10.2 3.8-15.4.2-.8-.3-1.7-1.2-2-.9-.3-1.8-.5-2.6-.7-.2 0-.3-.1-.2-.3.3-1.1.6-2.3.9-3.4-.4.3-.4.3-.3.2zM28.2 41c.1 0 .2.1.2.1 1.6.4 3.3.9 5 1 1.2.1 2.3.1 3.4-.3 1.9-.6 2.7-3.1 1.6-4.7-.5-.8-1.3-1.3-2.1-1.8-1.8-1-3.9-1.4-5.9-1.8-.3-.1-.3 0-.4.3-.2 1-.5 1.9-.7 2.9-.4 1.4-.7 2.8-1.1 4.3zm8.4-10.2c.2 0 .7-.1 1.1-.2 1.9-.4 2.9-2.6 1.9-4.3-.5-.9-1.4-1.5-2.3-1.9-1.4-.6-2.8-.9-4.3-1.3-.3-.1-.4 0-.5.3-.5 2.1-1 4.1-1.6 6.2-.1.2 0 .3.2.4.4.1.7.2 1.1.3 1.5.2 2.8.5 4.4.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.f924ea64541bef78229a300fbccf08b1.svg";
export { ForwardRef as ReactComponent };